<div class="title-header">
  <span class="text-title">
    {{ title }}
  </span>

  <button class="btn-style flex justify-content-center align-items-center mx-1"
          (click)="action()"
  >
    <span class="material-symbols-outlined icon-style text-md">
      add
    </span>
    <span class="text-md">
      {{ textButton }}
    </span>
  </button>
</div>
